<script>
import { VIcon, VBtn, VProgressCircular } from 'vuetify/lib/components'
import Ripple from './active'

const buttonVariants = ['primary', 'secondary', 'tertiary', 'danger', 'destroy', 'link', 'fab', 'ghost']
export default {
  name: 'EButton',
  extends: VBtn,
  directives: {
    // custom ripple to trigger the active state
    Ripple,
  },
  props: {
    icon: {
      type: String,
      default: '',
    },
    variant: {
      type: String,
      default: 'primary',
      validator: (value) => {
        return buttonVariants.indexOf(value) !== -1
      },
    },
    label: {
      type: String,
      default: '',
    },
  },
  computed: {
    classes() {
      return {
        'e-button': true,
        'e-button--primary': this.variant === 'primary',
        'e-button--secondary': this.variant === 'secondary',
        'e-button--tertiary': this.variant === 'tertiary',
        'e-button--ghost': this.variant === 'ghost',
        'e-button--danger': this.variant === 'danger',
        'e-button--destroy': this.variant === 'destroy',
        'e-button--link': this.variant === 'link',
        'e-button--fab': this.variant === 'fab',
        'e-button--with-icon': this.icon,
        ...VBtn.options.computed.classes.call(this),
        'v-btn--icon': false,
        'v-btn--round': false,
        'v-btn--is-elevated': false,
      }
    },
    hasBg() {
      return false
    },
  },
  methods: {
    // click(e) {
    //   // TODO: Remove this in v3
    //   this.active = true
    //   !this.retainFocusOnClick && !this.fab && e.detail && this.$el.blur()
    //   this.$emit('click', e)
    //   this.btnToggle && this.toggle()
    //   this.active = false
    // },
    genContent() {
      const data = {
        props: {
          size: this.small ? '16px' : this.large ? '24px' : '20px',
        },
      }
      if (this.icon) {
        return this.$createElement(
          'span',
          {
            staticClass: 'v-btn__content',
          },
          [this.$createElement(VIcon, data, this.icon)]
        )
      }
      return this.$createElement(
        'span',
        {
          staticClass: 'v-btn__content',
        },
        this.$slots.default || this.label
      )
    },
    genLoader() {
      return this.$createElement(
        'span',
        {
          class: 'v-btn__loader',
        },
        this.$slots.loader || [
          this.$createElement(VProgressCircular, {
            props: {
              indeterminate: true,
              size: 14,
              width: 2,
            },
          }),
        ]
      )
    },
  },
  render(h) {
    const children = [this.genContent(), this.loading && this.genLoader()]
    const { tag, data } = this.generateRouteLink()
    const setColor = this.hasBg ? this.setBackgroundColor : this.setTextColor

    if (tag === 'button') {
      data.attrs.type = this.type
      data.attrs.disabled = this.disabled
    }

    data.attrs.value = ['string', 'number'].includes(typeof this.value) ? this.value : JSON.stringify(this.value)
    data.on = {
      ...this.$listeners,
      click: this.click,
      // ...data.on,
    }
    return h(tag, this.disabled ? data : setColor(this.color, data), children)
  },
}
</script>
